(function () {
  function safeGetSessionValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : '';
    } catch (error) {
      return '';
    }
  }

  function safeSetSessionValue(key, value) {
    try {
      if (window.sessionStorage && value) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      /* Ignore storage failures. */
    }
  }

  function queryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function referrerHost() {
    try {
      if (!document.referrer) return '';
      var referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname;
    } catch (error) {
      return '';
    }
  }

  function sessionSource() {
    var source = queryParam('utm_source') || safeGetSessionValue('plume_aeo_session_source') || referrerHost() || 'direct';
    safeSetSessionValue('plume_aeo_session_source', source);
    return source;
  }

  function sessionMedium() {
    var medium = queryParam('utm_medium') || safeGetSessionValue('plume_aeo_session_medium');
    if (!medium) medium = referrerHost() ? 'referral' : 'none';
    safeSetSessionValue('plume_aeo_session_medium', medium);
    return medium;
  }

  function closestBridge(element) {
    return element && element.closest ? element.closest('.plume-aeo-product-bridge') : null;
  }

  function buildPayload(link, bridge) {
    return {
      page_path: window.location.pathname || '',
      page_type: bridge.getAttribute('data-page-type') || 'aeo_article',
      module_name: bridge.getAttribute('data-module-name') || 'why_plume_elite',
      module_position: bridge.getAttribute('data-module-position') || 'inline_early',
      cta_text: link.getAttribute('data-cta-text') || (link.textContent || '').trim(),
      destination_url: link.getAttribute('data-destination-url') || link.getAttribute('href') || '',
      product_entity: bridge.getAttribute('data-product-entity') || 'plume_elite_lash_brow_serum',
      competitor_context: bridge.getAttribute('data-competitor-context') || 'none',
      ingredient_context: bridge.getAttribute('data-ingredient-context') || 'prostaglandin_analog',
      session_source: sessionSource(),
      session_medium: sessionMedium()
    };
  }

  function isDevelopmentMode() {
    return window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      (window.Shopify && window.Shopify.designMode);
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function hasBlockingUi() {
    var selectors = [
      '.Drawer[aria-hidden="false"]',
      '.Popover[aria-hidden="false"]',
      '.Modal[aria-hidden="false"]',
      '#shopify-pc__banner',
      '#onetrust-banner-sdk',
      '[data-kl-scroll-locking-modal="true"]',
      '[class*="cookie"][role="dialog"]',
      '[aria-label*="cookie" i][role="dialog"]'
    ];
    var elements = document.querySelectorAll(selectors.join(','));

    for (var index = 0; index < elements.length; index += 1) {
      if (isVisible(elements[index])) return true;
    }
    return false;
  }

  function initMobileAction() {
    var bridge = document.querySelector('.plume-aeo-product-bridge');
    if (!bridge) return;

    var productLink = bridge.querySelector('a[href*="/products/lash-brow-enhancing-serum-elite"]');
    if (!productLink) return;

    var action = document.createElement('a');
    action.className = 'plume-aeo-mobile-action';
    action.href = productLink.getAttribute('href');
    action.textContent = 'View Plume Elite';
    action.setAttribute('aria-hidden', 'true');
    action.setAttribute('tabindex', '-1');
    bridge.appendChild(action);

    var footer = document.querySelector('.Footer');

    function updatePreviewOffset() {
      var bottomOffset = 16;
      var previewBar = document.getElementById('PBarNextFrameWrapper');
      if (isVisible(previewBar)) {
        var previewRect = previewBar.getBoundingClientRect();
        if (previewRect.bottom > window.innerHeight - 8) {
          bottomOffset = Math.max(bottomOffset, Math.ceil(previewRect.height + 16));
        }
      }

      var launcherSelectors = [
        '#google-merchantwidget-iframe-wrapper',
        '#ShopifyChat',
        'shopify-chat',
        'shopify-agent'
      ];
      var launchers = document.querySelectorAll(launcherSelectors.join(','));
      for (var launcherIndex = 0; launcherIndex < launchers.length; launcherIndex += 1) {
        if (!isVisible(launchers[launcherIndex])) continue;
        var launcherRect = launchers[launcherIndex].getBoundingClientRect();
        if (launcherRect.bottom > window.innerHeight / 2) {
          bottomOffset = Math.max(bottomOffset, Math.ceil(window.innerHeight - launcherRect.top + 12));
        }
      }

      action.style.setProperty('--plume-aeo-mobile-action-bottom', bottomOffset + 'px');
    }

    function updateAction() {
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      var bridgePassed = bridge.getBoundingClientRect().bottom < 0;
      var footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
      var show = isMobile && bridgePassed && !footerVisible && !hasBlockingUi();

      updatePreviewOffset();
      action.classList.toggle('is-visible', show);
      action.setAttribute('aria-hidden', show ? 'false' : 'true');
      action.setAttribute('tabindex', show ? '0' : '-1');
    }

    var updateQueued = false;
    function queueUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(function () {
        updateQueued = false;
        updateAction();
      });
    }

    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    document.addEventListener('click', function () {
      window.setTimeout(queueUpdate, 0);
    });
    updateAction();
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-aeo-cta="true"]') : null;
    if (!link) return;

    var bridge = closestBridge(link);
    if (!bridge) return;

    var payload = buildPayload(link, bridge);

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'aeo_cta_click', payload);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'aeo_cta_click',
        aeo_cta_click: payload
      });
    }

    if (isDevelopmentMode() && window.console && typeof window.console.info === 'function') {
      window.console.info('aeo_cta_click', payload);
    }
  }, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileAction);
  } else {
    initMobileAction();
  }
})();
